import React from 'react';

const InputText = (props) => {
    return (
        <div className={"relative " + props?.col}>
            <textarea onKeyDown={props?.handleKeyDown} ref={props?.textarearef} id={props.id} placeholder="" {...props} rows={6} disabled={props.disabled} style={props.style}
                    className={`block w-full px-2.5 pb-2 pt-2 text-sm text-gray-900 bg-transparent border-[1px] rounded-[3px]
                     border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer ${props.height ?? "" } ${props.fontFamily ?? "" }`}/>
            <label htmlFor={props.id}
                    className={`absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-[5px]
                    z-10 origin-[0] bg-white px-2 peer-placeholder-shown:top-0 peer-placeholder-shown:scale-100
                    peer-placeholder-shown:translate-y-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-2.5 peer-focus:top-[5px] 
                    ${ props.disabled  ? ((props.value || props.defaultValue) ? "bg-label-disabled" : "") : "bg-white"}`}>
                {props.label}
            </label>
        </div>
    );
};

export default InputText;